import React from 'react';
import style from './InsiderTrades.module.css';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import usePoliticianTransactions from '../../hooks/usePoliticianTransactions';
const CongressTradesTab = ({ stock }) => {
  const { politicianTransactions, isLoading } = usePoliticianTransactions(stock.id);

  if (isLoading) {
    return <p className={style.noData}>Loading congress trades…</p>;
  }

  if (!politicianTransactions) {
    return null;
  }

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const labels = [];
  for (let i = 5; i >= 0; i--) {
    const date = new Date();
    date.setMonth(date.getMonth() - i * 3);
    const quarter = Math.floor(date.getMonth() / 3) + 1;
    const year = date.getFullYear();
    labels.push(`Q${quarter} ${year}`);
  }

  const dataSell = [];
  const dataBuy = [];
  for (let i = 5; i >= 0; i--) {
    const date = new Date();
    const month = date.getMonth() - i * 3;
    date.setMonth(month - (month % 3));
    date.setDate(1);

    const politicianTransaction = politicianTransactions.find((politicianTransaction) => {
      const politicianTransactionDate = new Date(politicianTransaction.quarter);
      return (
        politicianTransactionDate.getFullYear() === date.getFullYear() &&
        politicianTransactionDate.getMonth() === date.getMonth() &&
        politicianTransactionDate.getDate() === date.getDate()
      );
    });
    if (politicianTransaction) {
      dataSell.push(politicianTransaction.count_sell);
      dataBuy.push(politicianTransaction.count_buy);
    } else {
      dataSell.push(0);
      dataBuy.push(0);
    }
  }

  const hasChartData = dataSell.some((value, index) => value > 0 || dataBuy[index] > 0);

  const data = {
    labels,
    datasets: [
      {
        label: 'Politicians Sold',
        data: dataSell,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        type: 'bar',
      },
      {
        label: 'Politicians Bought',
        data: dataBuy,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(60, 157, 14, 0.5)',
        type: 'bar',
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        intersect: false,
        mode: 'index',
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
        },
      },
    },
  };

  if (!hasChartData) {
    return <p className={style.noData}>No recent congress trades.</p>;
  }

  return (
    <div className="utilities__text-center">
      <Bar options={options} data={data} />
      <a href={`/congress-stock-trades?stock=${stock.symbol}`} className={style.link}>View list of trades</a>
    </div>
  );
};

export default CongressTradesTab;
